import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from "react-i18next";

const BlogDetails = () => {
  const { lang,slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [instagramPosts, setInstagramPosts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const postsPerPage = 3;
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';
  const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
  });

  useEffect(() => {
    i18n.changeLanguage(lang);
  }, [lang]);

  useEffect(() => {
    if (isArabic) {
      document.body.setAttribute('dir', 'rtl');
      document.body.style.textAlign = 'right';
    } else {
      document.body.setAttribute('dir', 'ltr');
      document.body.style.textAlign = 'left';
    }
  
    // cleanup (sayfadan çıkınca eski haline dönsün)
    return () => {
      document.body.setAttribute('dir', 'ltr');
      document.body.style.textAlign = 'left';
    };
  }, [isArabic]);
  

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/blog/${slug}`, {
          headers: { 'Accept-Language': lang },
        });
        setBlog(response.data);
      } catch (error) {
        console.error('Error fetching blog:', error.message);
      }
    };

    fetchBlog();
  }, [slug, lang]);

  useEffect(() => {
    if (blog) {
      document.title = blog.meta_title || blog.title;
      console.log(blog);

      const metaDescription = document.querySelector("meta[name='description']");
      if (metaDescription) {
        metaDescription.setAttribute("content", blog.meta_description || "No description available.");
      } else {
        const newMetaDescription = document.createElement("meta");
        newMetaDescription.name = "description";
        newMetaDescription.content = blog.meta_description || "No description available.";
        document.head.appendChild(newMetaDescription);
      }
    }
  }, [blog]);

  useEffect(() => {
    const fetchInstagramPosts = async () => {
      try {
        const response = await api.get('/api/instagram', {
          params: { page: currentPage, limit: postsPerPage },
        });
        setInstagramPosts(response.data.posts);
        setTotalPages(response.data.totalPages);
      } catch (error) {
        console.error('Error fetching Instagram posts:', error.message);
      }
    };
    fetchInstagramPosts();
  }, [currentPage]);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  if (!blog) {
    return <div className="container mt-5">Loading...</div>;
  }

  return (
    <div>
      <style>
        {`
          body {
            background-color: #f9f9f9;
            font-family: 'Arial', sans-serif;
          }

          .main-container {
            display: flex;
            flex-wrap: wrap;
            margin: 20px auto;
            padding-left:30px;
          }
            .main-container.rtl {
  flex-direction: row-reverse;
}
            .content img {
  max-width: 100%; /* Blog içindeki resimleri kapsar */
  height: auto; /* Yüksekliği oranlı şekilde ayarlar */
  display: block;
  margin: 0 auto; /* Resmi ortalar */
}
.instagram-module img {
  max-width: 100%; /* Konteynerin genişliğine göre boyutlandır */
  height: auto; /* Oranı koruyarak yüksekliği ayarlar */
  display: block; /* Görüntü akışını düzenler */
  margin: 0 auto;
}


          .blog-container {
            flex: 0 0 65%;
            background-color: #fff;
            padding: 20px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            border-radius: 10px;
          }

          .instagram-module {
            flex: 0 0 30%;
            background-color: #fff;
            margin-left: 20px;
            padding: 20px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            border-radius: 10px;
          }

          .instagram-posts img {
            width: 100%;
            border-radius: 5px;
            margin-bottom: 10px;
          }

          .pagination {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 20px;
          }

          .pagination button {
            padding: 5px 10px;
            background-color: #5a67d8;
            color: #fff;
            border: none;
            border-radius: 5px;
            cursor: pointer;
          }

          .content.rtl {
  direction: rtl;
  text-align: right;
}

          .pagination button:disabled {
            background-color: #ccc;
            cursor: not-allowed;
          }

          @media (max-width: 768px) {
            .instagram-module {
              display: none;
            }

            

            .blog-container {
        flex: 0 0 100%;
        margin: 0;
        padding: 10px;
      }

      .blog-container img {
        max-width: 100%;
        height: auto;
      }

      .content p {
        word-wrap: break-word;
        line-height: 1.5;
      }
          }
        `}
      </style>

      <div className={`main-container ${isArabic ? 'rtl' : ''}`}>

  <div className="blog-container">
    <h1>{blog.title}</h1>
    <div className="meta">
      <span>
        {t("publishedOn", { date: new Date(blog.createdAt).toLocaleDateString() })} | 
        {t("author")}: GanttMaster Team
      </span>
    </div>
    <div
      className={`content ${isArabic ? 'rtl' : ''}`}
      dangerouslySetInnerHTML={{ __html: blog.content }}
    />
  </div>

  {blog.instagramPost && (
    <div className="instagram-module">
      <h3>{t("instagramHighlight")}</h3>
      <img src={blog.instagramPost.image} alt={blog.instagramPost.caption} />
      <p><strong>{blog.instagramPost.caption}</strong></p>
      <p>{blog.instagramPost.description}</p>
      <a href={blog.instagramPost.link} target="_blank" rel="noopener noreferrer">
        {t("viewOnInstagram")}
      </a>
    </div>
  )}
</div>
    </div>
  );
};

export default BlogDetails;
